import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'
import { rockefeller } from '../system/environment/Config.json'
import { MsalToken } from '../system/msal/MsalToken'
import { MsalInstance } from '../system/msal/MsalInstance'
import { TotpSessionKey } from '../shared/Constants'
import { UAuthToken } from '../system/uauth/UAuthToken'

const fetchBaseRockefellerApiQuery = fetchBaseQuery({
  baseUrl: rockefeller.api.baseurl,
  prepareHeaders: async (headers: Headers, api) => {
    const state = api.getState() as RootState
    if (state.app.uAuthAccessToken) {
      const refreshedToken = await UAuthToken.getAccessToken(state.app.uAuthAccessToken)
      headers.append('Authorization', `Bearer ${refreshedToken}`)
    } else if (MsalInstance.getInstance().getAllAccounts()?.length > 0) {
      const tokenResult = await MsalToken.getAccessToken([rockefeller.api.scope])
      headers.append('Authorization', `${tokenResult.tokenType} ${tokenResult.accessToken}`)
    }
    headers.append('Content-Type', 'application/json; charset=UTF-8;')
    headers.append('cache-control', 'no-cache')
    headers.append('profilejson', state.app.profileKey ?? '')
    headers.append('contextjson', state.app.contextKey ?? '')

    if (state.app.totpSessionKey) {
      headers.append(TotpSessionKey, state.app.totpSessionKey)
    }

    if (rockefeller.api.version != null && rockefeller.api.version.trim() !== '') {
      headers.append('version', rockefeller.api.version)
    }
    return headers
  }
})

const RockefellerApiSlice = createApi({
  reducerPath: '@api/rockefeller',
  baseQuery: fetchBaseRockefellerApiQuery,
  endpoints: () => ({}),
  keepUnusedDataFor: 60 * 60,
  tagTypes: ['Refresh', 'MfaMethods']
})

export default RockefellerApiSlice
